export default {
    "data": {
        "h5": {
            "imgObj": {
                "top": "https://s21.lgstatic.com/growth/activity/20220315/1647311861968.png",
                "icon": "https://s20.lgstatic.com/growth/activity/20210830/1630295757727.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210830/1630309262590.png",
                "btn1": "https://s21.lgstatic.com/growth/activity/20210830/1630307896616.png",
                "btn2": "https://s21.lgstatic.com/growth/activity/20210830/1630308053349.png",
                "btn3": "https://s21.lgstatic.com/growth/activity/20210830/1630309308721.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20220426/1650954120283.png",
            },
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20210830/1630303756879.png",
                "https://s21.lgstatic.com/growth/activity/20210831/1630404110454.png",
                "https://s21.lgstatic.com/growth/activity/20210831/1630404118416.png",
                "https://s21.lgstatic.com/growth/activity/20210830/1630307414331.png",
                "https://s21.lgstatic.com/growth/activity/20210830/1630307433776.png",
                "https://s21.lgstatic.com/growth/activity/20210830/1630307448128.png",
                "https://s21.lgstatic.com/growth/activity/20210830/1630307475849.png"
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210830/1630309333677.png",
                "https://s20.lgstatic.com/growth/activity/20220315/1647311898685.png",
            ],
            "swiperList": [
                {
                    "imgUrl": "https://s21.lgstatic.com/growth/activity/20220624/1656056885239.png",
                    "url": "",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210406/1617674818225.png"
                },
                {
                    "imgUrl": "https://s20.lgstatic.com/growth/activity/20220624/1656056904176.png",
                    "url": "",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210406/1617674841913.png"
                },
                {
                    "imgUrl": "https://s21.lgstatic.com/growth/activity/20220624/1656056913413.png",
                    "url": "",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210406/1617674832574.png"
                },
                {
                    "imgUrl": "https://s20.lgstatic.com/growth/activity/20220624/1656056924180.png",
                    "url": "",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210406/1617674832574.png"
                }
            ],
            "swiperList2": [
                "https://s21.lgstatic.com/growth/activity/20220624/1656056933818.png",
                "https://s20.lgstatic.com/growth/activity/20220624/1656056942864.png",
                "https://s21.lgstatic.com/growth/activity/20220624/1656056952946.png",
                "https://s21.lgstatic.com/growth/activity/20220624/1656056963631.png"
            ],
            "imgtabList": [
                "https://s20.lgstatic.com/growth/activity/20220624/1656057280265.png",
                "https://s21.lgstatic.com/growth/activity/20220624/1656057291471.png"
            ]
        },
        "pc": {
            "imgObj": {
                "top": "https://s21.lgstatic.com/growth/activity/20220628/1656386882072.png",
                "icon": "https://s20.lgstatic.com/growth/activity/20210831/1630391898890.png",
                "btn_stage": "https://s20.lgstatic.com/growth/activity/20220628/1656388700597.png",
                "stage_img": "https://s21.lgstatic.com/growth/activity/20211020/1634717985689.png",
                "footer": "https://s20.lgstatic.com/growth/activity/20220426/1650954165993.png",
            },
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20220628/1656386956337.png",
                "https://s21.lgstatic.com/growth/activity/20220628/1656386967502.png",
                // "https://s21.lgstatic.com/growth/activity/20210831/1630380904706.png",
                // "https://s21.lgstatic.com/growth/activity/20210831/1630380926922.png",
                // "https://s21.lgstatic.com/growth/activity/20210831/1630380940934.png",
                // "https://s21.lgstatic.com/growth/activity/20210831/1630381991446.png"
            ],
            "imgtabList": [
                "https://s20.lgstatic.com/growth/activity/20210831/1630391107280.png",
                "https://s21.lgstatic.com/growth/activity/20210831/1630391118887.png"
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210831/1630392272913.png",
                "https://s20.lgstatic.com/growth/activity/20211126/1637918208047.jpg",
                "https://s20.lgstatic.com/growth/activity/20220315/1647312012659.png"
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210412/1618221479351.png",
                "https://s21.lgstatic.com/growth/activity/20210412/1618221489263.png",
                "https://s21.lgstatic.com/growth/activity/20210412/1618221498487.png"
            ]
        },
        "tabList": [
            { "stage": "职业发展" },
            { "stage": "私教模式" },
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "内推服务" },
        ],
        "tabList1": [
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "就业服务" },
            // { "stage": "私教模式" },
            // { "stage": "用户评价" },
        ],
        "stageList": [
            {
                "stage": "第一阶段",
                "title": "架构师框架底层设计能力及源码多维剖析",
                "phaseTargetList": [
                    "能够进行数据操作层衍生分析，把脉传统技术弊病",
                    "掌握Java持久层框架设计逻辑，纯手写Java持久层框架",
                    "理解MyBatis底层设计及机制原理",
                    "掌握MyBatis源码，理解底层代码架构逻辑"
                ],
                "skillsList": [
                    "自定义持久层框架",
                    "Mybatis复杂开发",
                    "Mybatis架构、缓存及插件",
                    "Mybatis源码多维下探剖析",
                    "自定义IoC 和AOP框架",
                    "BeanFactory与ApplicationContext",
                    "FactoryBean与BeanFactory"
                ],
                "details": [
                    {
                        "t": "模块一：持久层框架设计实现及MyBatis源码分析",
                        "desc": [
                            "通过持久层框架的衍生分析，推导出开发步骤进而纯手写持久层框架，对MyBatis技术系统复习后进行源码剖析。"
                        ]
                    },
                    {
                        "t": "模块二：IoC容器设计实现及Spring源码分析",
                        "desc": [
                            "从分析代码耦合到IoC思想演进，从功能代码抽取到面向切面AOP思想演进，最后会手写Spring和对Spring进行源码深入分析。"
                        ]
                    },
                    {
                        "t": "模块三：MVC框架设计实现及SpringMVC源码分析、通用数据操作接口设计、SpringData高级应用",
                        "desc": [
                            "本模块从MVC设计模式及前端控制器模型分析，手写属于自己的MVC框架，并对SpringMVC源码分析；对SpringData接口规范进行深入剖析。"
                        ]
                    },
                    {
                        "t": "模块四：约定优于配置设计范式及Spring Boot源码剖析",
                        "desc": [
                            "本模块将会剖析约定优于配置设计范式，并分析SpringBoot自动装配实现原理，并对SpringBoot源码进行剖析，探秘底层实现原理及框架设计思想。"
                        ]
                    },
                    {
                        "t": "模块五：安全框架设计实战及SpringSecurity源码剖析（选修）",
                        "desc": [
                            "本模块将会剖析Spring全家桶中的安全管理框架SpringSecurity，重点分析SpringSecurity认证和授权的核心流程，通过对其源码的剖析，探秘底层实现原理及框架设计思想。"
                        ]
                    },
                    {
                        "t": "模块六：响应式编程设计实战及SpringWebFlux源码剖析（选修）",
                        "desc": [
                            "本模块会对Spring5.0新引入的响应式编程技术进行全面剖析，掌握Reactor、WebFlux核心机制和内部原理，并对SpringWebFlux源码进行剖析，探秘底层实现原理及框架设计思想。"
                        ]
                    }
                ]
            },
            {
                "stage": "第二阶段",
                "title": "架构师大型分布式、微服务系统架构突击",
                "phaseTargetList": [
                    "掌握分布式架构理论、架构设计原则、网络通信、Netty、NIO等",
                    "掌握设计RPC框架的原则并能手写代码实现RPC框架 ",
                    "掌握分布式治理过程中问题处理方法，如权重、降级、容错路由等 ",
                    "掌握Zookeeper的底层原理及多维场景，分布式锁、共享锁、羊群效应等"
                ],
                "skillsList": [
                    "式架构理论及设计策略",
                    "分布式架构设计及网络实践",
                    "BIO、NIO、AIO 、Netty原理和实战 ",
                    "自定义RPC框架及分布式协调 ",
                    "Zookeeper系统模型及场景策略进阶",
                    "Zookeeper ZAB协议剖析",
                    "Zookeeper底层源码深度下探"
                ],
                "details": [
                    {
                        "t": "模块一：分布式理论、架构设计（自定义RPC）",
                        "desc": [
                            "本模块会对分布式架构的理论、架构设计、网络通信等进行讲解，并设计一个RPC远程过程调用框架并进行代码编写"
                        ]
                    },
                    {
                        "t": "模块二：分布式服务治理、分布式协调服务Zookeeper深入",
                        "desc": [
                            "本模块会对分布式治理中遇到的问题，例如权重、降级、容错路由等进行讲解，并对分布式协调服务Zookeeper进行系统的说明"
                        ]
                    },
                    {
                        "t": "模块三：高性能RPC框架Apache Dubbo",
                        "desc": [
                            "本模块对Apache的Dubbo进行高级使用及其源码分析，并对核心组件原理和处理流程进行剖析"
                        ]
                    },
                    {
                        "t": "模块四：SpringCloud组件设计原理及实战（上）",
                        "desc": [
                            "本模块对SpringCloud常用组件及其应用场景进行回顾，并对一些高级特性，例如链路追踪设计原理及Sleuth+Zipkin等进行讲解"
                        ]
                    },
                    {
                        "t": "模块五：SpringCloud组件设计原理及实战（下）",
                        "desc": [
                            "本模块对SpringCloud Alibaba常用组件及其应用场景进行剖析和实战，例如对Nacos、Sentinel和Seata等技术原理和源码方面的剖析"
                        ]
                    }
                ]
            },
            {
                "stage": "第三阶段",
                "title": "架构师大型分布式存储、缓存架构进阶",
                "phaseTargetList": [
                    "理解MySQL架构及底层设计",
                    "掌握海量数据MySQL分库分表、复杂实战及运维管理",
                    "掌握数据层生产性能优化策略",
                    "掌握MongoDB底层及集群架构"
                ],
                "skillsList": [
                    "MySQL架构、机制、引擎、索引、事务、锁等",
                    "海量数据分库分表架构设计",
                    "ShardingSphere、MyCat复杂场景实战应用",
                    "MySQL数据库实战规范及生产环境运维分析",
                    "SQL及MySQL性能优化方案",
                    "MongoDB Replica Sets&Sharded Cluster架构",
                    "MongoDB索引和Explain分析"
                ],
                "details": [
                    {
                        "t": "模块一：MySQL海量数据存储与优化（上）",
                        "desc": [
                            "本模块对MySQL体系架构、运行机制、存储引擎、索引原理、事务和锁以及集群架构设计等方面的内容进行深入系统的介绍，并对SQL和架构进行分析及提出性能优化方案"
                        ]
                    },
                    {
                        "t": "模块二：MySQL海量数据存储与优化（下）",
                        "desc": [
                            "本模块主要对MySQL海量数据处理中的分库分表架构、ShardingSphere、MyCat中间件实战应用、数据库实战规范、以及一些运维分析工具等内容进行讲解"
                        ]
                    },
                    {
                        "t": "模块三：分布式文档存储独角兽MongoDB、知识图谱存储数据库Neo4j（选修）",
                        "desc": [
                            "本模块对MongoDB的存储原理以及replica sets & Sharded Cluster等、对Neo4j数据模型及图形理论等进行深入讲解"
                        ]
                    },
                    {
                        "t": "模块四：轻量级分布式文件系统FastDFS、阿里云OSS云存储平台（选修）",
                        "desc": [
                            "本模块对分布式文件系统FastDFS集群架构与原理剖析，使用FastDFS+Nginx搭建高吞吐文件服务器，并对阿里云OSS云存储平台系统讲解"
                        ]
                    },
                    {
                        "t": "模块五：高性能分布式缓存Redis、分布式解决方案Codis",
                        "desc": [
                            "本模块对Redis底层存储结构和原理、持久化方案、删除策略、IO多路复用模型、Redis集群模式、预热、雪崩、击穿、穿透等进行系统剖析"
                        ]
                    },
                    {
                        "t": "模块六：Guava Cache、EVCache、Tair、Aerospike、Hazelcast（选修）",
                        "desc": [
                            "本模块对市场上其他缓存服务进行讲解，例如：Guava Cache、EVCache、Tair、Aerospike、Hazelcast等，可以提高在缓存方面的架构选型能力"
                        ]
                    }
                ]
            },
            {
                "stage": "第四阶段",
                "title": "企业级全域消息通信服务进阶实战",
                "phaseTargetList": [
                    "理解MQ中间件产品设计思想及原则",
                    "掌握MQ模型逻辑，封装实现自定义MQ",
                    "理解MQ架构原则及技术选型",
                    "掌握RabbitMQ底层架构、原理及生产实践"
                ],
                "skillsList": [
                    "分布式架构通信原理及设计原则、技术选型",
                    "自定义消息中间件",
                    "JMS架构模式详解及问题",
                    "AMQP协议剖析",
                    "RabbitMQ工作流程、模式及整合策略",
                    "RabbitMQ消息可靠性、TTL、死信队列、延迟队列",
                    "RabbitMQ集群与生产环境运维"
                ],
                "details": [
                    {
                        "t": "模块一：开源消息中间件RabbitMQ",
                        "desc": [
                            "本模块对市场上常用的开源消息中间件RabbitMQ进行深度源码剖析、并对ACK、限流、TTL、死信、延迟、集群等高级应用和原理进行讲解"
                        ]
                    },
                    {
                        "t": "模块二：Apache消息中间件RocketMQ",
                        "desc": [
                            "本模块对市场上常用的开源消息中间件RocketMQ进行深度源码剖析、并对零拷贝原理、刷盘机制、消息幂等、死信队列、优化配置、动态扩容缩容、集群搭建等高级应用和原理进行讲解"
                        ]
                    },
                    {
                        "t": "模块三：高吞吐消息中间件Kafka",
                        "desc": [
                            "本模块对Kafka集群原理和消息流处理流程、组件机制、流处理基础等进行深入讲解，对从架构选型角度对三种MQ进行比较"
                        ]
                    }
                ]
            },
            {
                "stage": "第五阶段",
                "title": "互联网亿级搜索技术架构实践进阶",
                "phaseTargetList": [
                    "理解倒排索引机制",
                    "掌握全文搜索引擎架构原则及设计",
                    "掌握Elastic Stack无缝衔接方案及实操关键点",
                    "掌握Elasticsearch数据模型、构建和算法扩展",
                ],
                "skillsList": [
                    "全文搜索引擎机制原理",
                    "Elasticsearch集群生产级架构及原理",
                    "Elasticsearch索引、映射、文档高级策略",
                    "聚合分析及零停机索引重建",
                    "Elasticsearch集群安全、管理及运维",
                    "Elasticsearch亿级数据场景模型策略",
                    "拉勾网亿级数据量搜索及集群调优实战"
                ],
                "details": [
                    {
                        "t": "模块一：引擎工具包Lucene、搜索应用服务器Solr（选修）",
                        "desc": [
                            "本模块将对Lucene倒排索引机制和底层存储结构深入讲解、对搜索服务引擎Solr高级特性进行剖析，并使用SolrCloud+Zookeeper进行集群化管理"
                        ]
                    },
                    {
                        "t": "模块二：亿级数据分析平台Elastic Stack",
                        "desc": [
                            "本模块将针对Elasticsearch的数据模型分析、构建和算法扩展进行深入讲解，结合拉勾网亿级数据量进行搜索实战，最后对ES进行性能调优"
                        ]
                    }
                ]
            },
            {
                "stage": "第六阶段",
                "title": "架构师云原生、虚拟化架构能力及生产实践",
                "phaseTargetList": [
                    "理解云原生、虚拟化基础原理",
                    "掌握虚拟化技术在信息化架构中的糅合流程",
                    "理解并掌握Docker容器虚拟化技术原理、应用策略",
                    "理解服务编排原理"
                ],
                "skillsList": [
                    "式架构理论及设计策略 云原生、虚拟化原理及架构体系",
                    "Docker架构设计",
                    "Docker环境 & 镜像策略 & 生产部署 & 运维管理",
                    "MySQL、微服务容器化部署",
                    "容器化实战项目",
                    "Kubernetes架构和核心组件策略",
                    "Kubernetes运行机制、安全机制、集群",
                ],
                "details": [
                    {
                        "t": "模块一：Docker容器虚拟化技术",
                        "desc": [
                            "本模块主要深入讲解Docker容器虚拟化技术原理及应用，涉及Docker安装、应用，引擎、容器、镜像、仓库核心组件剖析，DockerFile、Docker数据持久化等高级实战，Swarm集群管理、Docker Compose、私有仓库等"
                        ]
                    },
                    {
                        "t": "模块二：K8s容器编排系统",
                        "desc": [
                            "本模块主要深入讲解K8s容器编排系统，对K8s集群环境搭建、核心组件原理、工作机制、高可用、运维管理等方面进行讲解"
                        ]
                    },
                    {
                        "t": "模块三：CI/CD、DevOps（选修）",
                        "desc": [
                            "本模块主要深入讲解基于容器技术，实现开发运维测试一体化。对持续集成工具Jenkins、代码管理工具GitLab、与K8s环境集成等方面进行讲解"
                        ]
                    },
                    {
                        "t": "模块四：APM管理和性能监控工具（选修）",
                        "desc": [
                            "本模块主要深入讲解APM管理工具Skywalking、性能监控工具Pinpoint、代码质量管理工具Sonar等进行讲解"
                        ]
                    }
                ]
            },
            {
                "stage": "第七阶段",
                "title": "大型互联网项目综合实战与架构进阶",
                "phaseTargetList": [
                    "掌握大型互联网项目架构技巧、设计策略",
                    "掌握大型互联网项目0-1开发实施过程",
                    "掌握互联网10+场景技术解决方案",
                    "掌握大型互联网项目卡点问题定位、分析处理技巧"
                ],
                "skillsList": [
                    "大型在线教育项目0-1架构、解决方案和开发实战",
                    "大型在线教育项目压测发布和环境监控",
                    "大型互利网商业电商项目开发实战",
                ],
                "details": [
                    {
                        "t": "模块一：拉勾教育项目实战和解决方案",
                        "desc": [
                            "本模块会以真实开发流程，从需求分析、概要设计、详细设计、编码实现等几个环节对大型互联网项目进行讲解，其中涉及了很多互联网公司常用的解决方案，例如：秒杀、SSO、IM、Security、推送、三方支付、权限控制、分布式事务等，夯实之前所学技术。"
                        ]
                    },
                    {
                        "t": "模块二：项目压测发布和环境监控",
                        "desc": [
                            "本模块主要针对大型互联网项目的容器化发布过程进行讲解，涉及系统功能发布、压测、环境部署和监控等方面内容，对之前所学的容器化和监控技术进行加强。"
                        ]
                    },
                    {
                        "t": "模块三：大型电商项目实战和解决方案",
                        "desc": [
                            "本模块会以真实开发流程，从需求分析、概要设计、详细设计、编码实现等几个环节对大型互联网项目进行讲解，其中涉及了很多互联网公司常用的解决方案，例如：秒杀、三方支付、数据同步、分库分表、分布式事务、用户身份认证和授权解决方案等，夯实之前所学技术"
                        ]
                    },
                    {
                        "t": "模块四：项目压测发布和环境监控",
                        "desc": [
                            "本模块主要针对大型互联网项目的容器化发布过程进行讲解，涉及系统功能发布、压测、环境部署和监控等方面内容，对之前所学的容器化和监控技术进行加强"
                        ]
                    }
                ]
            },
            {
                "stage": "第八阶段",
                "title": "生产级调优专项及名企面试算法强化",
                "phaseTargetList": [
                    "掌握并发编程与JVM环境优化",
                    "掌握Linux性能监控与调优",
                    "掌握名企面试算法场景问题解决处理逻辑技巧"
                ],
                "skillsList": [
                    "多线程&并发设计原理",
                    "JUC并发编程详解",
                    "线程池与Future 、ForkJoinPool",
                    "多线程设计模式",
                    "并发测试与监视",
                    "类加载器及双亲委派",
                    "ClassLoader源码分析"
                ],
                "details": [
                    {
                        "t": "模块一：并发编程与环境优化",
                        "desc": [
                            "本模块会深入讲解线程高级部分，例如线程状态机制分析与线程池实现原理、抽象队列化同步器AQS等，还会深入JVM分析与调优，Linux性能监控与调优"
                        ]
                    },
                    {
                        "t": "模块二：Web应用安全与加速（选修）",
                        "desc": [
                            "本模块会剖析HTTP和HTTPS协议，加深理解Web交互机制，还会介绍各种防护技术，来抵御XSS、CSRF、注入等多种类型的攻击，并详解CDN加速实现原理，对系统访问速度进行优化"
                        ]
                    },
                    {
                        "t": "模块三：数据结构与算法",
                        "desc": [
                            "本模块会讲解算法高级内容，例如高级数据结构、排序、递归与回溯、深度与广度优先搜索、动态规划、二分搜索与贪婪算法等"
                        ]
                    }
                ]
            },
            {
                "stage": "第九阶段",
                "title": "求职面试技巧深度辅导",
                "phaseTargetList": [
                    "掌握专项技术能力面试路线",
                    "了解高分简历曝光核心点",
                    "能够结合自己情况撰写一份优秀的简历",
                    "了解面试过程中的那些「坑」"
                ],
                "skillsList": [
                    "迎接面试：专项能力突击",
                    "如何打造一份让人无法拒绝的简历",
                    "高分简历模板分析",
                    "打造一份高分简历的方法",
                    "模拟训练：重写简历1v1指导服务",
                    "如何在面试中发挥应有的实力",
                    "学会表达：如何把硬实力表达出来"
                ],
                "details": [
                    {
                        "t": "模块一：求职面试技巧深度辅导",
                        "desc": [
                            "本模块会教你怎么编写一份优秀的简历，怎样应对面试，也会有模拟面试环节，让你跟大厂技术面试官有提前训练的机会"
                        ]
                    }
                ]
            }
        ]
    }
}